import {
	Component, OnInit, OnChanges, SimpleChanges,
	Input, Output, ViewEncapsulation, EventEmitter } from '@angular/core';
import { Task } from '@task-utils/types';
import { Frame, language } from 'curvy';
import { suppliers_translations } from './suppliers.trans';
import { TaskRoutes } from '@task-utils/routes';
import { User } from '@task-modules/users';

type SupplierType = Pick<Task.Supplier, "name" | "email" | "company_type_id" | "cin" | "contact_phone" | "contact_name" | "identification_no" | "sectors" | "shelf_filler">
& {company_id?: number};

@Component({
	selector: 'task-create-edit-supplier',
	templateUrl: './create-edit-supplier.component.html',
	styleUrls: ['./create-edit-supplier.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class CreateEditSupplierComponent {
	@Input()
	supplier: SupplierType = {
		name: "",
		email: "",
		company_type_id: Task.COMPANY_TYPE.EXTERNAL_SUPPLIER,
		cin: "",
		contact_phone: "",
		contact_name: "",
		identification_no: "",
		sectors: [],
		shelf_filler: false,
	};

	is_edit = false;
	sectors:Task.Sector[] = [];
	picked_sectors: Task.Sector [] = [];
	picked_company: Task.Company = null;
	is_sys_admin = false;

	@Output('result')
	result: EventEmitter<Task.Supplier | SupplierType> = new EventEmitter();

	constructor() {
		language.load_translations(suppliers_translations);

	}

	async init() {
		if(this.supplier.name == "") {
			this.is_edit = false;
		} else {
			this.is_edit = true;
		}

		if (this.supplier.sectors.length) {
			this.picked_sectors = this.supplier.sectors;
		}


		this.is_sys_admin = await User.currentTypeIs(Task.USER_TYPE.SYSTEM_ADMIN);

	}

	async search_company(search: string) {
		let res = await TaskRoutes.companies.api_company_search(
			{ search: [Task.COMPANY_TYPE.MAIN], attributes: ["#=:company_type_id"] },
			{ page_no: 1, page_size: 10 }
	  );

		return res.data;
	}

	format_company_name(comp: Task.Company) {
		if (!comp) return;

		return `${comp.name}`;
	}
	
	async search_sectors() {
		this.sectors = (await TaskRoutes.sectors.api_sector_get_all({page_no: 1, page_size: 1000}, false)).data;
		return this.sectors
	}

	format_sector_name(sec: Task.Sector) {
		if (!sec) return;

		return `${sec.name}`;
	}

	
	ngOnInit() {
		
		this.init();
		
	}

	done() {
		if (this.supplier.company_type_id == null) {
			this.supplier.company_type_id = Task.COMPANY_TYPE.EXTERNAL_SUPPLIER;
		}

		this.supplier.sectors = this.picked_sectors;
		if (this.picked_company) {
			this.supplier.company_id = this.picked_company.company_id;
		}

		this.result.emit(this.supplier);

	}

	cancel() {
		this.result.emit(null);
	}
}
